import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { colors } from '../GlobalStyles';

const FooterContainer = styled.footer`
  background: ${colors.primaryDark};
  color: ${colors.white};
  padding: 3rem 2rem 2rem 2rem;

  @media (max-width: 768px) {
    padding: 2rem 1rem 1.5rem 1rem;
  }
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 1.5rem;
  }

  @media (max-width: 480px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    text-align: center;
  }
`;

const FooterSection = styled.div`
  h4 {
    color: ${colors.accentOrange};
    font-size: 1.1rem;
    font-weight: 600;
    margin-bottom: 1rem;
  }
`;

const FooterLink = styled.a`
  color: ${colors.white};
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.accentOrange};
  }
`;

const FooterRouterLink = styled(Link)`
  color: ${colors.white};
  text-decoration: none;
  display: block;
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.accentOrange};
  }
`;

const SocialIcons = styled.div`
  display: flex;
  gap: 1rem;
  margin-top: 0.5rem;

  @media (max-width: 480px) {
    justify-content: center;
  }
`;

const SocialIcon = styled.a`
  color: ${colors.white};
  font-size: 1.5rem;
  transition: color 0.3s ease;

  &:hover {
    color: ${colors.accentOrange};
  }
`;

const ContactInfo = styled.div`
  font-size: 0.9rem;
  line-height: 1.6;

  p {
    margin-bottom: 0.5rem;
  }
`;

const Copyright = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  margin-top: 2rem;
  padding-top: 1rem;
  text-align: center;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.7);
`;

export function Footer() {
  return (
    <FooterContainer id="contact">
      <FooterContent>
        <FooterSection>
          <h4>Follow us</h4>
          <SocialIcons>
            <SocialIcon
              href="https://www.linkedin.com/in/steve-widinghoff/"
              target="_blank"
              rel="noreferrer"
              title="LinkedIn"
            >
              💼
            </SocialIcon>
          </SocialIcons>
        </FooterSection>

        <FooterSection>
          <h4>Shortcuts</h4>
          <FooterLink href="/#services">Our services</FooterLink>
          <FooterLink href="/#about">About us</FooterLink>
          <FooterLink href="/#team">Our team</FooterLink>
        </FooterSection>

        <FooterSection>
          <h4>Legal</h4>
          <FooterRouterLink to="/terms-of-use">Terms of use</FooterRouterLink>
          <FooterRouterLink to="/privacy">Privacy</FooterRouterLink>
          <FooterRouterLink to="/integrity-policy">Integrity policy</FooterRouterLink>
          <FooterRouterLink to="/cookies">Cookies</FooterRouterLink>
        </FooterSection>

        <FooterSection>
          <h4>Contact us</h4>
          <ContactInfo>
            <p>
              <strong>Address:</strong>
            </p>
            <p>Located in Umeå, Sweden</p>
            <p>
              <strong>Business Hours:</strong>
            </p>
            <p>Mon-Fri: 09:00 - 18:00 CET</p>
            <p>Sat-Sun: Closed</p>
            <p>
              <strong>Email:</strong>
            </p>
            <FooterLink href="mailto:steve+wp@abrovinc.com">steve@abrovinc.com</FooterLink>
            <p style={{ marginTop: '1rem' }}>
              <strong>LinkedIn:</strong>
            </p>
            <FooterLink
              href="https://www.linkedin.com/in/steve-widinghoff/"
              target="_blank"
              rel="noreferrer"
            >
              Steve Widinghoff
            </FooterLink>
          </ContactInfo>
        </FooterSection>
      </FooterContent>

      {/* prettier-ignore */}
      <Copyright>© {new Date().getFullYear()} Abrovinc. All rights reserved. | Smart solutions to tricky problems.</Copyright>
    </FooterContainer>
  );
}
